import { render, staticRenderFns } from "./InformacionClinicaTab.vue?vue&type=template&id=56f21c15&scoped=true&"
import script from "./InformacionClinicaTab.vue?vue&type=script&lang=ts&"
export * from "./InformacionClinicaTab.vue?vue&type=script&lang=ts&"
import style0 from "./InformacionClinicaTab.vue?vue&type=style&index=0&id=56f21c15&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f21c15",
  null
  
)

export default component.exports